import { Modal, Input, Form, Tooltip, Checkbox } from 'antd';
import React from 'react';
import { Button, FormSelect, Widget, MasterDetailForm } from '@digital/ui';
import { getAllMatchingOptions } from '@app/api/autorizacaoPagamento/matching';
import { handleMatchingAutorizacao } from '@app/api/autorizacaoPagamento/autorizacao';
import { hasPermission } from '@app/helpers/permissions';

export default class ModalMatching extends React.Component {
  state = {
    matchingOption: this.props.matchingOption,
    options: [{}],
    visible: false,
    canMatch: false,
    idAutorizacao: this.props.idAutorizacao,
    numeroContrato: this.props.numeroContrato,
    statusCodigo: this.props.statusCodigo,
  };

  showModal = () => {
    let data = getAllMatchingOptions(this.state.idAutorizacao, this.state.numeroContrato);

    this.setState({
      options: data,
      visible: true,
    });
  };

  handleMatching = () => {
    handleMatchingAutorizacao(this.state.idAutorizacao, this.state.matchingOption).then(resp => {
      this.setState({
        visible: false,
      });
      return resp;
    });
  };

  handleConfirmMatch = e => {
    this.setState({
      canMatch: e.target.checked,
    });
  };

  handleCancel = e => {
    // this.limparCampo();
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <div>
        <Tooltip title="Realizar Matching">
          <Button onClick={this.showModal} icon="messaging-send_file" />
        </Tooltip>
        <Modal
          title="Realizar Matching"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          bodyStyle={{ height: 170 }}
          footer={[
            <div>
              {this.state.statusCodigo == 3 && (
                <Button
                  disabled={
                    (!this.state.canMatch && this.state.matchingOption != '0') || !hasPermission(['MATCHING_EDITAR'])
                  }
                  key="submit"
                  type="primary"
                  onClick={() => this.handleMatching()}>
                  Salvar
                </Button>
              )}
            </div>,
          ]}>
          <MasterDetailForm>
            <Widget>
              <FormSelect
                label="Selecione uma opção para realizar o Matching"
                placeholder="Selecione uma opção"
                required
                options={this.state.options}
                name="option"
                value={this.state.matchingOption}
                onSelect={value => {
                  this.setState({ matchingOption: value });
                }}
                span={12}
              />
              {
                <Checkbox disabled={this.state.matchingOption == '0'} onChange={this.handleConfirmMatch}>
                  Estou ciente de que ao confirmar o match não será mais possível trocar o documento de cobrança
                  associado à Autorização!
                </Checkbox>
              }
            </Widget>
          </MasterDetailForm>
        </Modal>
      </div>
    );
  }
}
